// extracted by mini-css-extract-plugin
export var closeButton = "_hg-2";
export var closeButtonIcon = "_hg-3";
export var lightboxContent = "_hg-1";
export var lightboxOverlay = "_hg-0";